import useId from '../utils/useId';
import * as React from 'react';
export const akulakuSvg = React.forwardRef(function akulakuSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.003 4c6.63 0 12.002 5.372 12.002 12.002C28.005 22.628 22.633 28 16.003 28 9.377 28 4 22.628 4 16.002 4 9.372 9.377 4 16.003 4Z',
      fill: `url(#bi_akulaku__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.172 18.46c-2.05-.448-3.293-2.338-2.94-4.497.309-1.89 1.95-3.134 3.82-3.149l.682.08c1.597.318 2.9 1.76 2.98 3.616 0 2.517-1.985 4.507-4.542 3.95Zm-4.268-7.273c-3.153 4.875 1.154 10.725 6.472 9.53a6.39 6.39 0 0 0 1.154-.372c.179-.085.358-.17.527-.264.328-.199.557-.348.93-.646.174-.145.219-.279.468-.304.174.045.413.856 1.348.786.572-.045.99-.487 1.114-.99v-.547c-.09-1.01-.18-1.995-.353-2.994-.22-1.274-.642-3.054-1.348-4.084-1.134-1.661-2.418-2.368-4.323-2.746-2.263-.343-4.735.702-5.989 2.632Zm12.256-.08c-.189-.974-.91-2.795-1.298-3.74-.184-.437-.86-1.487-.134-1.676.612-.16 1.502.488 1.79.716.642.508 1.299 2.353 1.667 3.388.522 1.472 2.159 8.247 1.064 9.316-.686.677-1.482.304-1.795-.169-.264-.632-.214-.995-.244-1.74l-.268-2.403c-.155-1.254-.473-2.557-.782-3.691Z',
      fill: `url(#bi_akulaku__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_akulaku__a_${id_0}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform: 'rotate(-61.845 16.901 -21.094) scale(25.1392)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEFEFE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.502,
          stopColor: '#ED3237',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#ED3237',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_akulaku__b_${id_1}`,
          x1: 19.165,
          y1: 10.614,
          x2: 3.961,
          y2: 31.455,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FEFEFE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#ED3237',
        }),
      ),
    ),
  );
});
akulakuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var akulaku = {
  category: 'brand',
  colorable: false,
  name: 'akulaku',
  svg: akulakuSvg,
};
